import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';

const Item = Form.Item;

class AddressForm extends React.Component{
	render(){
		
        const { getFieldDecorator } = this.props.form;
        const { communicator, addressDetails, alt } = this.props
        const title = !alt?communicator.charAt(0).toUpperCase() + communicator.slice(1):null


		return (
			<Form onSubmit={!alt?this.handleSubmit: this.handleSubmitAlt}>
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Item>
                                    {getFieldDecorator('name', {
                                        initialValue:addressDetails && addressDetails.name?addressDetails.name:null,
                                        rules: [
                                            { required: true, message: 'Name is required!' },
                                            // { type: 'name', message: 'The input is not valid E-mail!'},
                                        ],
                                    })(          
                                        alt?
                                        <Input placeholder="Name"/>
                                        :
                                        <Input placeholder={`${title} Name`}/>
                                    )}
                                    </Item>
                                </Col>
                                <Col span={12}>
                                    <Item>
                                    {getFieldDecorator('hp', {
                                        initialValue:addressDetails && addressDetails.hp?addressDetails.hp:null,
                                        rules: [
                                            { required: true, message: 'HP is required!' }
                                        ],
                                    })(       
                                    <Input placeholder="Phone Number"/>
                                    )}
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Item>
                                    {getFieldDecorator('companyName', {
                                            initialValue:addressDetails && addressDetails.companyName?addressDetails.companyName:null,
                                            rules: [
                                                { required: true, message: 'Company is required!' }
                                            ],
                                        })(      
                                        <Input placeholder="Company Name"/>
                                        )}
                                    </Item>
                                </Col>
                                <Col span={12}>
                                    <Item>
                                    {getFieldDecorator('country', {
                                            initialValue:addressDetails && addressDetails.country?addressDetails.country:null,
                                            rules: [
                                                { required: true, message: 'Country is required!' }
                                            ],
                                        })(      
                                    <Input placeholder="Country"/>
                                        )}
                                    </Item>
                                </Col>
                            </Row>
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Item>
                                        {getFieldDecorator('postalCode', {
                                                initialValue:addressDetails && addressDetails.postalCode?addressDetails.postalCode:null,
                                                rules: [
                                                    { required: true, message: 'Postal is required!' }
                                                ],
                                            })( 
                                        <Input placeholder="Postal Code"/>
                                            )}
                                    </Item>
                                </Col>
                                <Col span={12}>
                                    <Item>
                                        {getFieldDecorator('unit', {
                                                initialValue:addressDetails && addressDetails.unit?addressDetails.unit:null,
                                            })( 
                                        <Input placeholder="Unit"/>
                                            )}
                                    </Item>
                                </Col>
                            </Row>
                            <Row>
                                <Item>
                                    {getFieldDecorator('address', {
                                            initialValue:addressDetails && addressDetails.address?addressDetails.address:null,
                                            rules: [
                                                { required: true, message: 'Address is required!' }
                                            ],
                                        })( 
                                     <Input placeholder="Address"/>
                                        )}
                                </Item>
                            </Row>
                            <Row type="flex" justify="center">
                                <Button htmlType="submit">
                                    {alt?
                                    `Submit`
                                    :
                                    `Set ${communicator}`
                                    }
                                </Button>
                            </Row>
                        </Form>
		)
	}

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFieldsAndScroll((err, values) => {
		  if (!err) {
			this.props.setAddressDetails(values)
		  }
		});
      }
      
    handleSubmitAlt = (e)=>{
        e.preventDefault();
		this.props.form.validateFieldsAndScroll((err, values) => {
		  if (!err) {
              this.props.setAlternateAddress(values)
		  }
		});
    }
}

export default Form.create({})(AddressForm);


// WEBPACK FOOTER //
// ./src/components/orders-v2/addressForm.js